import React from 'react';

import Folder from './Folder/Folder';

const Folders = ({
  folders,
  onToggler,
  togglers,
  selected,
  onSetSelected,
  originalSelected = null,
}) => {
  return (
    <React.Fragment>
      {folders.map((f) => (
        <Folder
          key={f.id}
          file={f}
          onToggler={onToggler}
          togglers={togglers}
          selected={selected}
          onSetSelected={onSetSelected}
          originalSelected={originalSelected}
        />
      ))}
    </React.Fragment>
  );
};

export default Folders;
